module.exports = "/packs/step3-sp-8b56d25cbeb276a79ffa8bf9fb4ca170.png";